import { supabase } from './supabase';

/**
 * Read columns of the signed-in account's own users row.
 *
 * Signed-in accounts are losing SELECT on the private users columns (email,
 * credits, tags...); the own row comes from the get_my_user() function
 * instead (frontend migration 20261005220000). Until that function exists in
 * a database (deploy order, a fresh environment), fall back to the direct
 * read, which works there because the column lock ships after the function.
 */
export async function readMyUser<T extends Record<string, any>>(columns: string): Promise<T | null> {
  const viaFunction = await supabase.rpc('get_my_user').select(columns).maybeSingle();
  if (!viaFunction.error) return (viaFunction.data as unknown as T) ?? null;

  // PGRST202: the function isn't in this database's API yet.
  if (viaFunction.error.code !== 'PGRST202') {
    console.warn('get_my_user failed:', viaFunction.error.message);
    return null;
  }
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.user?.id) return null;
  const direct = await supabase.from('users').select(columns).eq('id', session.user.id).maybeSingle();
  if (direct.error) {
    console.warn('Own users row read failed:', direct.error.message);
    return null;
  }
  return (direct.data as unknown as T) ?? null;
}
